import {
  HELP_VIDEO_FETCH_ALL,
  HELP_VIDEO_FETCH_ALL_SUCCESS,
  HELP_VIDEO_FETCH_ALL_FAIL,
  // HELP_VIDEO_ADD,
  // HELP_VIDEO_ADD_SUCCESS,
  // HELP_VIDEO_ADD_FAIL,
  HELP_VIDEO_UPDATE,
  HELP_VIDEO_UPDATE_SUCCESS,
  HELP_VIDEO_UPDATE_FAIL,
  HELP_VIDEO_DELETE,
  HELP_VIDEO_DELETE_SUCCESS,
  HELP_VIDEO_DELETE_FAIL,
  HELP_VIDEO_SET_SORT,
  HELP_VIDEO_SET_PAGE,
  HELP_VIDEO_SET_PAGE_SIZE,
  HELP_VIDEO_SET_VIEW
} from './constants';

export const fetchHelpVids = () => ({
  type: HELP_VIDEO_FETCH_ALL
});
export const fetchHelpVidsSuccess = helpVids => ({
  type: HELP_VIDEO_FETCH_ALL_SUCCESS, helpVids
});
export const fetchHelpVidsFail = error => ({
  type: HELP_VIDEO_FETCH_ALL_FAIL, error
});
// export const addHelpVid = helpVid => ({
//   type: HELP_VIDEO_ADD, helpVid
// });
// export const addHelpVidSucccess = helpVid => ({
//   type: HELP_VIDEO_ADD_SUCCESS, helpVid
// });
// export const addHelpVidFail = error => ({
//   type: HELP_VIDEO_ADD_FAIL, error
// });
export const updateHelpVid = (helpVid, cloudFilesToRemove = []) => ({
  type: HELP_VIDEO_UPDATE, helpVid, cloudFilesToRemove
});
export const updateHelpVidSuccess = helpVid => ({
  type: HELP_VIDEO_UPDATE_SUCCESS, helpVid
});
export const updateHelpVidFail = (error, helpVid) => ({
  type: HELP_VIDEO_UPDATE_FAIL, error, helpVid
});
export const deleteHelpVid = (helpVid, cloudFilesToRemove = []) => ({
  type: HELP_VIDEO_DELETE, helpVid, cloudFilesToRemove
});
export const deleteHelpVidSuccess = () => ({
  type: HELP_VIDEO_DELETE_SUCCESS
});
export const deleteHelpVidFail = (error, helpVid) => ({
  type: HELP_VIDEO_DELETE_FAIL, error, helpVid
});
export const setAdminHelpVidSort = sort => ({
  type: HELP_VIDEO_SET_SORT, sort
});
export const setHelpVidPage = page => ({
  type: HELP_VIDEO_SET_PAGE, page
});
export const setHelpVidPageSize = size => ({
  type: HELP_VIDEO_SET_PAGE_SIZE, size
});
export const setHelpVideoView = isAdmin => ({
  type: HELP_VIDEO_SET_VIEW, isAdmin
});
